import { render, staticRenderFns } from "./news26.vue?vue&type=template&id=7afa2402&"
import script from "./news26.vue?vue&type=script&lang=js&"
export * from "./news26.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports